import { morphism } from 'morphism';
import { createStrictSchema } from '../../utils/morph.js';

const infoBuyerAdReplySchema = createStrictSchema({
    email: 'email',
    forwardPhone: 'forward_phone',
    phone: 'phone',
    name: 'name',
    userId: 'user_id',
});
const buyerInfoAdReplySchema = createStrictSchema({
    buyerInfo: {
        path: 'data',
        fn: morphism(infoBuyerAdReplySchema),
    },
});
const infoAdReplySchema = createStrictSchema({
    email: 'email',
    name: 'name',
    body: 'body',
    cc: 'cc',
    acceptTermsConds: 'accept_terms_conds',
    phone: 'phone',
    forwardPhone: 'forward_phone',
});
const adReplySchema = createStrictSchema({
    reply: {
        path: 'data',
        fn: morphism(infoAdReplySchema),
    },
});

export { adReplySchema, buyerInfoAdReplySchema, infoAdReplySchema, infoBuyerAdReplySchema };
//# sourceMappingURL=morph.js.map
